// ** React Imports
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'


import { useTranslation } from 'src/utils/i18n'

import dayjs from 'dayjs'

// ** MUI Imports
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

// ** Store & Actions Imports
import { useDispatch, useSelector } from 'react-redux'
import { selectMessage, fetchUserProfile, fetchChatsContacts, removeSelectedChat } from 'src/store/apps/telegram'

// ** Hooks
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import { formatDateToMonthShort } from 'src/@core/utils/format'

import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Chat App Components Imports
import TelegramSideBar from 'src/@core/components/telegram/telegram-side-bar'
import TelegramContent from 'src/@core/components/telegram/telegram-content'
import TelegramContacts from 'src/@core/components/telegram/telegram-contacts'

import PerfectScrollbarComponent from 'react-perfect-scrollbar'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

// component
import ChatCall from 'src/@core/components/common/chatCall'

import { getAllDashboard } from '/src/@api/dashboard'

import { Spin, Pagination } from 'antd'
import { setCurrentTab, changeExtremeService } from 'src/store/apps/Common'
import { generateMockData } from 'src/utils'
import { getUserAccountOrder } from 'src/@api/login'

const Telegram = () => {
  const { t } = useTranslation('common')

  // ** States
  const [userStatus, setUserStatus] = useState('online')
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false)
  const [userProfileLeftOpen, setUserProfileLeftOpen] = useState(false)
  const [userProfileRightOpen, setUserProfileRightOpen] = useState(false)
  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务

  const [fetchLoading, setFetchLoading] = useState(true) // 数据获取中

  // ** Hooks
  const theme = useTheme()
  const { settings } = useSettings()
  const dispatch = useDispatch()
  const hidden = useMediaQuery(theme.breakpoints.down('lg'))

  const store = useSelector(state => state.Telegram)

  // ** Vars
  const { skin } = settings
  const smAbove = useMediaQuery(theme.breakpoints.up('sm'))
  const sidebarWidth = smAbove ? 370 : 300
  const mdAbove = useMediaQuery(theme.breakpoints.up('md'))

  const [chat, setChat] = useState(true)
  const [headImg, setHaedImg] = useState('/images/telegram/2.jpg')

  useEffect(() => {
    dispatch(fetchUserProfile())
    dispatch(fetchChatsContacts())
  }, [dispatch])
  const handleLeftSidebarToggle = () => setLeftSidebarOpen(prev => !prev)
  const handleUserProfileLeftSidebarToggle = () => setUserProfileLeftOpen(prev => !prev)
  const handleUserProfileRightSidebarToggle = () => setUserProfileRightOpen(prev => !prev)

  const [switchDataType, setSwitchDataType] = useState('activity')

  let selectSwitchDataStyle = {
    background: '#121444',
    color: '#fff',
    display: 'inline-block',
    width: '90px',
    height: '26px',
    lineHeight: '26px',
    fontSize: '18px',
    textAlign: 'center'
  }

  let switchDataStyle = {
    display: 'inline-block',
    width: '90px',
    height: '26px',
    lineHeight: '26px',
    fontSize: '18px',
    textAlign: 'center'
  }

  let [chatCallData, setChatCallData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)

  const [total, setTotal] = useState(0)

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  const getChatCallData = async nowOffset => {
    const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

    // 获取最近的10笔订单
    let res = await getUserAccountOrder({ page: 1, pageSize: 10 })

    // 查找有限期最长的订单
    const lastOrder = res.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]

    // 计算是否为增值服务上线前付费用户

    // 增值服务上线前付费用户状态更新

    let data = await getAllDashboard({
      username,
      params: {
        category: 'TELEGRAM_INTERACTION',
        offset: nowOffset,
        limit: pagination.reqNum,
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
      }
    })

    setTotal(data.data.totalCount)

    const advanced = username == null || !('advanced' in data) || ['true', true].includes(data?.advanced) // 高级服务开通状态
    setAdvanced(advanced)
    dispatch(changeExtremeService(advanced)) // 更新高级服务状态

    if (data.data.contents == null) {
      setPagination(page => ({ ...page, maxNum: true }))
      setFetchLoading(false)

      return
    }

    let result = data.data.contents.map(row => {
      return {
        ...row,
        date: dayjs(row.date).format('YYYY-MM-DD HH:mm:ss'),
        icon: 'prime:send',
        color: row.isFromMe ? '#585858' : '#D43538'
      }
    })

    if (!advanced) result = generateMockData(result)

    setChatCallData(old => ([...old, ...result]))

    setFetchLoading(false)
  }

  // 设备切换时重置列表并重新拉数
  useDeviceScopedInit(
    useCallback(() => {
      setChatCallData([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setCurrentPage(1)
      setTotal(0)
      setFetchLoading(true)
      getChatCallData(0)
    }, [])
  )

  // 升级成功后重拉本页数据（监听 extreme-upgraded，逻辑对齐 useDeviceScopedInit）
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      setChatCallData([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setCurrentPage(1)
      setTotal(0)
      setFetchLoading(true)
      getChatCallData(0)
    }, [])
  )

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100 && advanced) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(page => ({ ...page, nowOffset }))

      if (!pagination.maxNum) getChatCallData(nowOffset)
    }
  }, [scroll])

  useEffect(() => {
    const title = t('Telegram')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch])

  return (
    <>
      {/* <div
        style={{
          height: 'auto',
          width: '180px',
          boxShadow: '0px 2px 10px 0px rgba(76, 78, 100, 0.22)',
          borderRadius: '10px',
          marginBottom: '10px',
          overflow: 'hidden',
          cursor: 'pointer'
        }}
      >
        <span
          style={switchDataType == 'activity' ? selectSwitchDataStyle : switchDataStyle}
          onClick={() => setSwitchDataType('activity')}
        >
          ACTIVITY
        </span>
        <span
          style={switchDataType == 'chat' ? selectSwitchDataStyle : switchDataStyle}
          onClick={() => setSwitchDataType('chat')}
        >
          CHAT
        </span>
      </div> */}

      {switchDataType == 'activity' ? (
        <>
          <ChatCall dom={dom} data={chatCallData} advanced={advanced} fetchLoading={fetchLoading} />
          {/* <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row-reverse', marginTop: '20px' }}>
            <Pagination
              pageSizeOptions={[50]}
              total={total}
              pageSize={50}
              current={currentPage}
              color='primary'
              onChange={(page, pageSize) => setCurrentPage(page)}
            />
          </Box> */}
        </>
      ) : null}

      {switchDataType == 'chat' ? (
        <Box
          className='app-chat'
          sx={{
            width: '100%',
            minHeight: 'calc(var(--vh)*100 - 370px)',
            display: 'flex',
            borderRadius: 1,
            position: 'relative',
            boxShadow: skin === 'bordered' ? 0 : 6,
            ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
          }}
        >
          <TelegramSideBar
            store={store}
            hidden={hidden}
            mdAbove={mdAbove}
            dispatch={dispatch}
            userStatus={userStatus}
            selectMessage={selectMessage}
            getInitials={getInitials}
            sidebarWidth={sidebarWidth}
            setUserStatus={setUserStatus}
            leftSidebarOpen={leftSidebarOpen}
            removeSelectedChat={removeSelectedChat}
            userProfileLeftOpen={userProfileLeftOpen}
            formatDateToMonthShort={formatDateToMonthShort}
            handleLeftSidebarToggle={handleLeftSidebarToggle}
            handleUserProfileLeftSidebarToggle={handleUserProfileLeftSidebarToggle}
            headImg={headImg}
            setChat={setChat}
            chat={chat}
            setHaedImg={setHaedImg}
          />
          {chat && (
            <TelegramContent
              store={store}
              hidden={hidden}
              mdAbove={mdAbove}
              dispatch={dispatch}
              getInitials={getInitials}
              sidebarWidth={sidebarWidth}
              userProfileRightOpen={userProfileRightOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
              headImg={headImg}
              setHaedImg={setHaedImg}
            />
          )}

          {chat === false ? (
            <TelegramContacts
              store={store}
              hidden={hidden}
              mdAbove={mdAbove}
              dispatch={dispatch}
              getInitials={getInitials}
              sidebarWidth={sidebarWidth}
              userProfileRightOpen={userProfileRightOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
              headImg={headImg}
              setHaedImg={setHaedImg}
            />
          ) : (
            ''
          )}
        </Box>
      ) : null}
    </>
  )
}

Telegram.contentHeightFixed = true

export default Telegram


